import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';
import {
    createImageSlide,
    createVideoSlide,
} from 'sections/welcomeAnim/costumeVariations/mediaCarousel/carouselSlide.util';

export const BlackSetItems: CustomSlide[] = [
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/1%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/3%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/33%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/44%401x.jpg'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/5%401x.jpg'
    ),
    createVideoSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/welcomeAnim1.mp4'
    ),
    createVideoSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/blackAnim2.mp4',
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/33%401x.jpg'
    ),
];
